// luxury-pair-with.js
class LuxuryPairWith extends HTMLElement {
  constructor() {
    super();
    this.checkboxes = this.querySelectorAll('.luxury-pair-card__checkbox');
    this.variantSelects = this.querySelectorAll('.luxury-pair-card__variants');
    this.totalPriceEl = this.querySelector('.luxury-pair-with__total-price');
    this.submitBtn = this.querySelector('.luxury-pair-with__btn');
    
    this.currencySymbol = this.dataset.currencySymbol || '$';
    
    this.list = this.querySelector('.luxury-pair-with__list');
    this.prevBtn = this.querySelector('.luxury-pair-arrow--left');
    this.nextBtn = this.querySelector('.luxury-pair-arrow--right');

    this.bindEvents();
    this.calculateTotal();
  }

  bindEvents() {
    this.checkboxes.forEach(box => {
      box.addEventListener('change', (e) => {
        const card = e.target.closest('.luxury-pair-card');
        if (e.target.checked) {
          card.classList.add('is-selected');
        } else {
          card.classList.remove('is-selected');
        }
        this.calculateTotal();
      });
    });

    this.variantSelects.forEach(select => {
      select.addEventListener('change', (e) => {
        // Update price data attribute based on selected variant
        const selectedOption = e.target.options[e.target.selectedIndex];
        const price = selectedOption.dataset.price;
        const checkbox = e.target.closest('.luxury-pair-card').querySelector('.luxury-pair-card__checkbox');
        checkbox.dataset.price = price;
        this.calculateTotal();
      });
    });

    this.submitBtn.addEventListener('click', this.handleAddToCart.bind(this));

    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.list.scrollBy({ left: -this.list.clientWidth * 0.8, behavior: 'smooth' });
      });
      this.nextBtn.addEventListener('click', () => {
        this.list.scrollBy({ left: this.list.clientWidth * 0.8, behavior: 'smooth' });
      });
    }
  }

  calculateTotal() {
    let total = 0;
    let checkedCount = 0;

    this.checkboxes.forEach(box => {
      if (box.checked) {
        checkedCount++;
        total += parseFloat(box.dataset.price || 0);
      }
    });

    // Format money (basic formatter, assumes cents)
    const formattedTotal = (total / 100).toFixed(2);
    this.totalPriceEl.textContent = `${this.currencySymbol}${formattedTotal}`;

    // Disable button if nothing is selected
    if (checkedCount === 0) {
      this.submitBtn.disabled = true;
      this.submitBtn.querySelector('.btn-text').textContent = 'Select items to add';
    } else {
      this.submitBtn.disabled = false;
      this.submitBtn.querySelector('.btn-text').textContent = `Add Selected to Cart`;
    }
  }

  async handleAddToCart() {
    const items = [];
    
    this.checkboxes.forEach(box => {
      if (box.checked) {
        const card = box.closest('.luxury-pair-card');
        const select = card.querySelector('.luxury-pair-card__variants');
        const variantId = select ? select.value : box.dataset.variantId;
        
        items.push({
          id: parseInt(variantId, 10),
          quantity: 1
        });
      }
    });

    if (items.length === 0) return;

    this.submitBtn.classList.add('is-loading');

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      // Trigger Dawn's native cart update event to open the drawer
      document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      
      // Reset state if desired, or let user keep them checked
      this.submitBtn.classList.remove('is-loading');
      this.submitBtn.querySelector('.btn-text').textContent = 'Added to Cart!';
      
      setTimeout(() => {
        this.calculateTotal(); // Resets button text
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);
      this.submitBtn.classList.remove('is-loading');
      alert('There was an issue adding these items to your cart.');
    }
  }
}

customElements.define('luxury-pair-with', LuxuryPairWith);
